export default __webpack_public_path__ + "static/media/VideoCallMockup.90e752b6.png";